export default function Main({ 
  title = 'BCN - Brahmin Community Network', 
  description = 'Connect with the Brahmin community for business, matrimonial, jobs, spirituality, and social networking. Join BCN to discover opportunities and build meaningful connections.',
  image = '/logo.png', 
  largeImage = true,
  structuredData = null,
  keywords = 'brahmin community, business network, matrimonial, jobs, spirituality, social networking, BCN',
  author = 'BCN India',
  canonical = null
}) {
  // If image is already a full URL, use it as-is; otherwise prepend origin
  image = image.startsWith('http://') || image.startsWith('https://') 
    ? image 
    : window.location.origin + image
  const url = canonical || (window.location.origin + window.location.pathname)

  // Update title
  document.querySelector('title').innerText = title
  document.querySelector('meta[name="title"]').content = title
  document.querySelector('meta[name="description"]').content = description

  // Update Open Graph tags
  document.querySelector('meta[property="og:title"]').content = title
  document.querySelector('meta[property="og:description"]').content = description
  document.querySelector('meta[property="og:image"]').content = image
  document.querySelector('meta[property="og:url"]').content = url

  // Update Twitter tags (using name attribute for better compatibility)
  let twitterTitle = document.querySelector('meta[name="twitter:title"]')
  if (!twitterTitle) {
    twitterTitle = document.createElement('meta')
    twitterTitle.name = 'twitter:title'
    document.head.appendChild(twitterTitle)
  }
  twitterTitle.content = title

  let twitterDesc = document.querySelector('meta[name="twitter:description"]')
  if (!twitterDesc) {
    twitterDesc = document.createElement('meta')
    twitterDesc.name = 'twitter:description'
    document.head.appendChild(twitterDesc)
  }
  twitterDesc.content = description

  let twitterImage = document.querySelector('meta[name="twitter:image"]')
  if (!twitterImage) {
    twitterImage = document.createElement('meta')
    twitterImage.name = 'twitter:image'
    document.head.appendChild(twitterImage)
  }
  twitterImage.content = image

  let twitterUrl = document.querySelector('meta[name="twitter:url"]')
  if (!twitterUrl) {
    twitterUrl = document.createElement('meta')
    twitterUrl.name = 'twitter:url'
    document.head.appendChild(twitterUrl)
  }
  twitterUrl.content = url

  // Update Twitter card type
  let twitterCard = document.querySelector('meta[name="twitter:card"]')
  if (!twitterCard) {
    twitterCard = document.createElement('meta')
    twitterCard.name = 'twitter:card'
    document.head.appendChild(twitterCard)
  }
  twitterCard.content = largeImage ? 'summary_large_image' : 'summary'

  // Add additional meta tags if they don't exist
  let metaKeywords = document.querySelector('meta[name="keywords"]')
  if (!metaKeywords) {
    metaKeywords = document.createElement('meta')
    metaKeywords.name = 'keywords'
    document.head.appendChild(metaKeywords)
  }
  metaKeywords.content = keywords

  let metaAuthor = document.querySelector('meta[name="author"]')
  if (!metaAuthor) {
    metaAuthor = document.createElement('meta')
    metaAuthor.name = 'author'
    document.head.appendChild(metaAuthor)
  }
  metaAuthor.content = author

  // Update canonical URL
  let canonicalLink = document.querySelector('link[rel="canonical"]')
  if (!canonicalLink) {
    canonicalLink = document.createElement('link')
    canonicalLink.rel = 'canonical'
    document.head.appendChild(canonicalLink)
  }
  canonicalLink.href = url

  // Add structured data if provided
  if (structuredData) {
    // Remove existing structured data
    const existingScripts = document.querySelectorAll('script[type="application/ld+json"]')
    existingScripts.forEach(script => script.remove())

    // Handle both single objects and arrays of structured data
    const dataArray = Array.isArray(structuredData) ? structuredData : [structuredData]
    
    // Add each structured data object as a separate script tag
    dataArray.forEach((data) => {
      if (data) {
        const script = document.createElement('script')
        script.type = 'application/ld+json'
        script.text = JSON.stringify(data)
        document.head.appendChild(script)
      }
    })
  }

  window.scrollTo(0, 0)
}
